import { OrderedSet } from 'immutable';

function checkIsListReady(
    matchIdsWithVisibilityFlags: OrderedSet<string> | undefined,
    matchIds: OrderedSet<string>
): boolean {
    return !!(
        (matchIdsWithVisibilityFlags && matchIdsWithVisibilityFlags.size) ||
        matchIds.size
    );
}

export default checkIsListReady;
